'use client'

/* eslint-disable @next/next/no-async-client-component */
import { useState, useEffect } from 'react'
import { PATHWAY } from '@/modules/httpService'
import { IFeedRecord } from '@/interfaces/IFeedRecord'
import RelatedPost from '@/components/display/RelatedPost'
import styles from './RelatedPosts.module.scss'
import { useTranslations } from 'next-intl'

function RelatedPosts ({ id }: { id: string }) {
  const t = useTranslations('RelatedPosts')
  const [records, setRecords] = useState<IFeedRecord[]>([])

  async function loadPosts (id: string) {
    const referrer = document.referrer
    const res = await PATHWAY.get(`/posts/${id}/related`, {
      headers: {
        'X-Referer': referrer
      }
    })
    setRecords(res.data.data.related)
  }

  useEffect(() => {
    if (id) loadPosts(id)
  }, [])

  return (
    <div className={styles.wrapper}>
      <h4>{t('more-articles')}</h4>
      <div className={styles.recordsWrapper}>
        {records.map((record, i) => (
          <RelatedPost
            key={i}
            id={record.id}
            title={record.title}
            slug={record.slug}
            image={record.image}
            createdBy={record.createdBy}
          />
        ))}
      </div>
    </div>
  )
}

export default RelatedPosts
